import React from 'react';
import styles from './index.less';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import * as imgSrc from '@/assets/default-node-cover.png';
// import FTooltip from '@/components/FTooltip';
import FPopoverPure from '@/components/FPopoverPure';
import fMessage from '@/components/fMessage';

function Examples({}) {

  const [$nodes, set$nodes, get$nodes] = FUtil.Hook.useGetState<{
    nodeID: number;
    cover: string;
    title: string;
    labels: string[];
    about: string;
    href: string;
  }[]>([]);

  AHooks.useMount(async () => {

    const { ret, errCode, msg, data }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        dataList: {
          nodeId: number;
          nodeDomain: string;
          nodeName: string;
          nodeTitle: string;
          nodeShortDescription: string;
          nodeLogo: string;
          tags: string[],
        }[];
      }
    } = await FServiceAPI.Node.searchForClient({
      nodeType: 1,
      limit: 100,
      // status: 0,
      // @ts-ignore
      nodeType: 1,
      // @ts-ignore
      sort: 'nodeTypeUpdateDate:-1',
    });
    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }

    // console.log(data, 'FFFFFFFFFFFFFFFFFFFFFFFFF');
    set$nodes(data.dataList.map((dl) => {
      return {
        nodeID: dl.nodeId,
        cover: dl.nodeLogo || imgSrc,
        title: dl.nodeTitle || dl.nodeName,
        labels: dl.tags,
        // labels: ['1234567890123456789012345678901234567890123456789012345678901234567890'],
        about: dl.nodeShortDescription,
        href: FUtil.Format.completeUrlByDomain(dl.nodeDomain),
        // href: '',
      };
    }));
  });

  return (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <div style={{ height: 50 }} />
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <FComponentsLib.FContentText
        type='negative'
        text={'Freelog为用户展示了一些场景示例，用户可以根据自己的需求选择主题或创建主题来搭建自己的节点'}
      />
    </div>
    <div style={{ height: 50 }} />
    <div className={styles.nodes}>
      {
        $nodes.map((node) => {
          return (<NodeCard
            key={node.nodeID}
            nodeID={node.nodeID}
            cover={node.cover}
            title={node.title}
            labels={node.labels}
            about={node.about}
            href={node.href}
          />);
        })
      }

    </div>
    <div style={{ height: 100 }} />
  </div>);
}

export default Examples;

interface NodeCardProps {
  nodeID: number;
  cover: string;
  title: string;
  labels: string[];
  about: string;
  href: string;
}

function NodeCard({ nodeID, cover, title, labels, about, href }: NodeCardProps) {
  // const ref = React.useRef(null);
  // const size = AHooks.useSize(ref);

  const [$labels, set$labels, get$labels] = FUtil.Hook.useGetState<string[]>([]);
  const [$more, set$more, get$more] = FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(() => {
    const result = handledLabelsData(labels);
    // console.log(result, 'result sdiofjdslkjflksdjlkfjl');
    set$labels(result.labels);
    set$more(result.more);
  });

  return (<div style={{ display: 'inline-block', width: 'fit-content', height: 'fit-content', position: 'relative' }}>
    <a className={styles.node}
       target={'_blank'}
       href={href}
       title={FI18n.i18nNext.t('discover_nodes_tooltips_view')}
    >
      <div className={styles.img}>
        <img src={cover} alt={''} />
      </div>
      <div style={{ height: 20 }} />
      <FComponentsLib.FTitleText
        text={title}
        type={'h2'}
        style={{ maxWidth: '100%', fontWeight: 600 }}
        singleRow={true}
      />
      <div style={{ height: 20 }} />
      <div style={{ height: 24 }} />

      <div style={{ height: 20 }} />
      <FComponentsLib.FContentText
        className={styles.about}
        text={about}
        type={'additional2'}
        style={{ textAlign: 'center' }}
      />
    </a>

    <div
      className={styles.labels}
    >
      {
        $labels
          .map((label, labelIndex) => {
            return (<div
              key={labelIndex}
              className={styles.label}
            >{label}</div>);
          })
      }
      {
        $more && (<FPopoverPure
          // open={true}
          placement={'right'}
          content={<div className={styles.PopoverLabels}>
            {
              labels.map((l, i) => {
                return (<label key={i}>{l}</label>);
              })
            }

          </div>}
        >
          <div>
            <FComponentsLib.FContentText
              text={'...'}
              type={'additional2'}
              style={{ color: '#222', cursor: 'pointer' }}
            />
          </div>
        </FPopoverPure>)
      }
    </div>
  </div>);
}

function handledLabelsData(dataSource: string[]): {
  labels: string[];
  more: boolean;
} {
  const THRESHOLD: number = 32;
  const result: string[] = [];
  let resultItem: string = '';
  let len: number = 0;
  for (const str of dataSource) {
    if (resultItem !== '') {
      len += 2;
    }
    resultItem = '';

    for (const s of str) {
      // console.log(s, 's dsfikjsd;lkfjlksdjlkj');
      if (!isFullWidthCharacter(s)) {
        len += .5;
      } else {
        len++;
      }

      if (len < THRESHOLD) {
        resultItem += s;
      } else {
        resultItem += '...';
        break;
      }
    }
    result.push(resultItem);
    if (len >= THRESHOLD) {
      break;
    }
  }
  return {
    labels: result,
    more: len >= THRESHOLD,
  };
}

function isFullWidthCharacter(character: string) {
  const chinesePattern = new RegExp(/[\u4E00-\u9FA5]/);
  const fullWidthPunctuationPattern = new RegExp(/[\uFF00-\uFFEF]/);

  return chinesePattern.test(character) || fullWidthPunctuationPattern.test(character);
}
